"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentSearchEventType = exports.ContentSearchContentType = void 0;
const t = __importStar(require("io-ts"));
exports.ContentSearchContentType = t.intersection([
    t.type({
        lang: t.string,
        filterType: t.array(t.string),
        entityType: t.union([t.null, t.array(t.string)]),
        query: t.string,
        status: t.array(t.record(t.string, t.unknown)),
        product: t.union([t.null, t.string]),
        labels: t.array(t.union([t.null, t.string])),
        cases: t.union([t.null, t.string]),
        accessRestrictions: t.union([t.null, t.array(t.string)]),
        isContribution: t.union([t.null, t.boolean]),
        size: t.number,
    }),
    t.partial({
        knowledgeId: t.union([t.null, t.string]),
        knowledge: t.union([t.null, t.string]),
        correlationId: t.string,
        searchFrom: t.number,
    }),
]);
exports.ContentSearchEventType = t.intersection([
    t.type({
        search: exports.ContentSearchContentType,
        displayedHits: t.number,
        totalHits: t.number,
    }),
    t.partial({
        knowledgeId: t.union([t.null, t.string]),
        source: t.string,
        query: t.string,
        correlationId: t.string,
        filters: t.type({
            // chrome_ext
            type: t.array(t.string),
            categories: t.array(t.string),
        }),
        focusEntity: t.union([
            t.type({
                id: t.string,
                type: t.string,
            }),
            t.null,
        ]),
        modalEntity: t.union([
            t.type({
                id: t.string,
                type: t.string,
            }),
            t.null,
        ]),
        // web_ext (only for search.abort) -> move to `hit`
        searchOutput: t.array(t.type({
            __typename: t.string,
            id: t.string,
            breadcrumb: t.array(t.string),
            ancestors: t.array(t.string),
            type: t.string,
            updatedAt: t.number, // web_ext -> to remove
        })),
    }),
]);
